import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (email, password) => api.post('/auth/register', { email, password }),
  getMe: () => api.get('/auth/me'),
};

export const communitiesAPI = {
  getAll: (params) => api.get('/communities', { params }),
  getById: (id) => api.get(`/communities/${id}`),
  create: (data) => api.post('/communities', data),
  update: (id, data) => api.put(`/communities/${id}`, data),
  delete: (id) => api.delete(`/communities/${id}`),
};

export const startupsAPI = {
  getAll: (params) => api.get('/startups', { params }),
  getById: (id) => api.get(`/startups/${id}`),
  create: (data) => api.post('/startups', data),
  update: (id, data) => api.put(`/startups/${id}`, data),
  delete: (id) => api.delete(`/startups/${id}`),
};

export const eventsAPI = {
  getAll: (params) => api.get('/events', { params }),
  getById: (id) => api.get(`/events/${id}`),
  create: (data) => api.post('/events', data),
  update: (id, data) => api.put(`/events/${id}`, data),
  delete: (id) => api.delete(`/events/${id}`),
};

export const jobsAPI = {
  getAll: (params) => api.get('/jobs', { params }),
  getById: (id) => api.get(`/jobs/${id}`),
  create: (data) => api.post('/jobs', data),
  update: (id, data) => api.put(`/jobs/${id}`, data),
  delete: (id) => api.delete(`/jobs/${id}`),
};

export const topicsAPI = {
  getAll: () => api.get('/topics'),
  getBySlug: (slug) => api.get(`/topics/${slug}`),
  create: (data) => api.post('/topics', data),
};

export const forumAPI = {
  getAll: (params) => api.get('/forum', { params }),
  getById: (id) => api.get(`/forum/${id}`),
  create: (data) => api.post('/forum', data),
};

export const blogAPI = {
  getAll: (params) => api.get('/blog', { params }),
  getBySlug: (slug) => api.get(`/blog/${slug}`),
  create: (data) => api.post('/blog', data),
  update: (slug, data) => api.put(`/blog/${slug}`, data),
  delete: (slug) => api.delete(`/blog/${slug}`),
};

export const newsletterAPI = {
  subscribe: (email) => api.post('/newsletter/subscribe', null, { params: { email } }),
  getSubscribers: () => api.get('/newsletter/subscribers'),
};

export const coworkingAPI = {
  getAll: () => api.get('/coworking'),
  create: (data) => api.post('/coworking', data),
};

export const successStoriesAPI = {
  getAll: () => api.get('/success-stories'),
  create: (data) => api.post('/success-stories', data),
};

export const searchAPI = {
  global: (q) => api.get('/search', { params: { q } }),
};

export const statsAPI = {
  get: () => api.get('/stats'),
};

export default api;
